import exclamatory from "../images/exclamatory.svg";
export default function Tooltip({className}) {
  return (
    <div className={`w-1/2 flex justify-end ${className}`}>
      <div className="min-w-52 flex justify-between items-center p-2 border-tooltip border-solid border-[#808080] mt-4 mb-3 shadow-md rounded">
        <img src={exclamatory} alt="alert_line" />
        <p className="text-left text-sm w-4/5 text-black font-notoSans">
          Please fill out this field
        </p>
      </div>
    </div>
  );
}
